export const mainMenu = {
  MAIN_MENU_ITEM_CLICKED: 'mainMenu.itemClicked'
}
